(function() {
    'use strict';
    
a3_cabin_reports.factory('SpecialMealTypeFactory', SpecialMealTypeFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SpecialMealTypeFactory
    * @description 
    *   Manage SpecialMealTypes.
    * @ngInject
    */
function SpecialMealTypeFactory(localStorageMD5Service ) {

        /**
         * Initialiaze SpecialMealType object 
         * @memberof SpecialMealTypeFactory
         */
		function SpecialMealType() {
			this.Code = null;
		}

		var callback=SpecialMealType;
		var type ='specialMealTypes';
			
		var service = {
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			formObjects : formObjects,
			toObjectList : toObjectList,
			getSpecialMealTypesFromStorage : getSpecialMealTypesFromStorage,
			getSpecialMealTypesFromStorageAsStrings : getSpecialMealTypesFromStorageAsStrings,
			setSpecialMealTypesToStorage : setSpecialMealTypesToStorage,
			getSpecialMealTypesFromStorageAsObjects : getSpecialMealTypesFromStorageAsObjects
		}
	
        /**
         * Extend given SpecialMealType object 
         * @memberof SpecialMealTypeFactory
         * @param {object} obj The SpecialMealType object that will be extended
         * @returns {object} SpecialMealType
         */
		function fromObject(obj) {
			if (obj == null) return null;
			var specialMealType = new SpecialMealType();
			specialMealType.Code = obj.code + ' - ' + obj.label;
			return specialMealType;
		}

        /**
         * Extend given SpecialMealType object list
         * @memberof SpecialMealTypeFactory
         * @param {array} objList The list of SpecialMealType objects that will be extended
         * @returns {object} SpecialMealTypes
         */
		function fromObjectList(objList) {
			if (objList == null) return null;

			var arrayLength = objList.length;
			var specialMealTypes = [];

			for (var i = 0; i < arrayLength; i++) {
				var specialMealType = new SpecialMealType();
				specialMealType.Code = objList[i].code + ' - ' + objList[i].label;
				specialMealTypes.push(specialMealType);
			}

			return specialMealTypes;
		}

        /**
         * Extend given SpecialMealType object list
         * @memberof SpecialMealTypeFactory
         * @param {array} objList The list of SpecialMealType objects that will be extended
         * @returns {object} SpecialMealTypes
         */
		function formObjects(objList) {
			if (objList == null) 
				return null;

			var arrayLength = objList.length;
			var specialMealTypes = new Array();

			for (var i = 0; i < arrayLength; i++) {
				var specialMealType = new SpecialMealType();
				specialMealType.Code = objList[i].code
				specialMealType.Label = objList[i].label;
				specialMealTypes.push(specialMealType);
			}
			return specialMealTypes;
		}
    
    
        /**
         * Get all the SpecialMealType's Code from given list
         * @memberof SpecialMealTypeFactory
         * @param {array} objectList An object list
         * @returns {array} SpecialMealTypes
         */
		function toObjectList(objList) {
			if (specialMealTypeList == null) return null;

			var arrayLength = specialMealTypeList.length;
			var objList = [];

			for (var i = 0; i < arrayLength; i++) {
				objList.push(specialMealTypeList[i].Code);
			}

			return objList;
		}

        /**
         * Get all the SpecialMealType objects
         * @memberof SpecialMealTypeFactory
         * @returns {array} SpecialMealTypes
         */
		function getSpecialMealTypesFromStorage() {
			var specialMealTypes = localStorageMD5Service.get('specialMealTypes');
			return fromObjectList(specialMealTypes);
		}

        /**
         * Get all the SpecialMealType full objects
         * @memberof SpecialMealTypeFactory
         * @returns {array} SpecialMealTypes
         */
		function getSpecialMealTypesFromStorageAsObjects() {
			var specialMealTypes = localStorageMD5Service.get('specialMealTypes');
			return formObjects(specialMealTypes);
		}

        /**
         * Get all the SpecialMealType's codes from local storage
         * @memberof SpecialMealTypeFactory
         * @returns {array} SpecialMealTypes
         */
		function getSpecialMealTypesFromStorageAsStrings() {
			var result = [];
			var objs = getSpecialMealTypesFromStorage();
			for (var i = 0; i < objs.length; i++) {
				result.push(objs[i].Code);
			}
			return result;
		}

    
        /**
         * Set all the SpecialMealTypes
         * @memberof SpecialMealTypeFactory
         * @param {array} objects A list of SpecialMealTypes.
         */
		function setSpecialMealTypesToStorage(specialMealTypes) {
			localStorageMD5Service.set('specialMealTypes', specialMealTypes);
		}

	return service;
	}

})();
